export default "__VITE_ASSET__3BuB1ro$__"